/* eslint-disable warp-drive/no-legacy-request-patterns */
import { service } from '@ember/service';
import Route from '@ember/routing/route';

import { isEmpty } from '@ember/utils';
import { hash } from '@linc-technologies/linced-common/utils/promise';
import { compact, mapBy } from '@linc-technologies/linced-common/utils/arrays';

export default class LineItemRoute extends Route {
  // Services
  @service
  store;

  model(params) {
    let person = this.modelFor('people.person').person;
    let promises = {
      person,
      item: this.store.findRecord('finance/line-item', params.lineitem_id),
      transactions: this.store.query('finance/transaction', {
        lineItemId: params.lineitem_id,
      }),
    };
    let caregiverIds = compact(
      mapBy(person.get('learner.primaryContacts'), 'caregiverId'),
    );
    if (!isEmpty(caregiverIds)) {
      promises.caregivers = this.store.query('person', {
        people: JSON.stringify(caregiverIds),
      });
    }

    return hash(promises);
  }
}
